/* Desktop mega: hover/focus open/close with ESC to close */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function (panel) {
    let closeTimer;

    function open() {
      clearTimeout(closeTimer);
      panel.setAttribute('open', '');
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => panel.removeAttribute('open'), 150);
    }

    panel.addEventListener('mouseenter', open);
    panel.addEventListener('mouseleave', scheduleClose);

    const content = panel.querySelector('.mega-menu__content');
    if (content) {
      content.addEventListener('mouseenter', open);
      content.addEventListener('mouseleave', scheduleClose);
    }

    panel.addEventListener('focusin', open);
    panel.addEventListener('focusout', (e) => {
      if (!panel.contains(e.relatedTarget)) scheduleClose();
    });
  });
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]')
      .forEach(d => d.removeAttribute('open'));
  }
});

/* =============================
   Tabbed mega: behavior rules (CLICK-ONLY MODELS)
   - Models: click (or Enter/Space) → activate panel (no hover activation)
   - Makes: click (or Enter/Space) toggles their model list; closes the other
   - Exposes recall hooks: menu.__openMake(mk) and menu.__activateTab(id)
   - NEW: opening a CLOSED make also activates its FIRST model
   ============================= */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mega-menu--tabs').forEach(function (menu) {
    const q  = (s) => menu.querySelector(s);
    const qa = (s) => Array.from(menu.querySelectorAll(s));
    const esc = (str) => (window.CSS && CSS.escape) ? CSS.escape(str) : str;

    function setContextFromLink(link){
      const ctx = menu.querySelector('[data-tabs-context]');
      if (!ctx || !link) return;
      const mk = (link.dataset.make || '').toUpperCase();
      const model = (link.textContent || '').trim().toUpperCase();
      ctx.textContent = mk && model ? (mk + ' ' + model) : (model || mk || '');
    }

    function activateTab(id, link) {
      if (!id) return;

      // rail active state
      qa('.tabs-rail__item.is-active').forEach(li => li.classList.remove('is-active'));
      if (link) link.closest('.tabs-rail__item')?.classList.add('is-active');

      // panel active state
      qa('.tab-panel.is-active').forEach(p => p.classList.remove('is-active'));
      const panel = q('#' + esc(id)) || q(`[id="${id}"]`);
      if (panel) panel.classList.add('is-active');

      // header text
      setContextFromLink(link || q(`.tabs-rail a[data-panel="${id}"], .tabs-rail a[href="#${id}"]`));
    }

    // --- Recall hook: allow menu-state.js to activate a tab safely
    menu.__activateTab = (id) => {
      const a = q(`.tabs-rail a[data-panel="${esc(id)}"], .tabs-rail a[href="#${esc(id)}"]`);
      activateTab(id, a || null);
    };

    // Helper: open a specific make group and close others
    function openMake(mk){
      if (!mk) return;
      const targetBtn  = q(`.tabs-make__button[data-make="${esc(mk)}"]`);
      const targetList = q(`.tabs-rail__list[data-make="${esc(mk)}"]`);
      if (!targetBtn || !targetList) return;

      // close all
      qa('.tabs-make__button[data-make]').forEach(other => {
        const omk = other.dataset.make;
        const ol  = q(`.tabs-rail__list[data-make="${esc(omk)}"]`);
        if (ol) { other.setAttribute('aria-expanded', 'false'); ol.hidden = true; }
      });

      // open requested
      targetBtn.setAttribute('aria-expanded','true');
      targetList.hidden = false;
    }

    // --- Recall hook: allow menu-state.js to open a make
    menu.__openMake = openMake;

    /* Models → CLICK/KEYBOARD ONLY (no hover activation) */
    qa('.tabs-rail a[data-panel], .tabs-rail a[href^="#"]').forEach(a => {
      const id = a.dataset.panel || (a.getAttribute('href') || '').replace(/^#/, '');
      a.addEventListener('click', e => {
        if (!id) return;
        e.preventDefault();
        activateTab(id, a);
      });
      a.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(id, a);
        }
      });
    });

/* Makes → click to open/close; auto-close others
   NEW: when opening a closed make, auto-activate its first model
*/
qa('.tabs-make__button[data-make]').forEach(btn => {
  const mk = btn.dataset.make;
  const list = q(`.tabs-rail__list[data-make="${esc(mk)}"]`);
  if (!list) return;

  // Normalize aria to actual visibility on load
  const openNow = !list.hidden;
  btn.setAttribute('aria-expanded', openNow ? 'true' : 'false');

  function closeAllMakes() {
    qa('.tabs-make__button[data-make]').forEach(other => {
      const ok = other.dataset.make;
      const ol = q(`.tabs-rail__list[data-make="${esc(ok)}"]`);
      if (ol) { other.setAttribute('aria-expanded','false'); ol.hidden = true; }
    });
  }

  function openThis() {
    btn.setAttribute('aria-expanded','true');
    list.hidden = false;
  }

  btn.addEventListener('click', (e) => {
    e.preventDefault();

    // true if this make's list is currently visible
    const isOpen = !list.hidden;

    // First close everything
    closeAllMakes();

    if (!isOpen) {
      // We are OPENING this make
      openThis();

      // AUTO-ACTIVATE: click the first model in this make
      const firstLink = list.querySelector('a[data-panel], a[href^="#"]');
      if (firstLink) {
        // Dispatch a real click so both mega-menu-hover + menu-state savers run
        firstLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    }
    // If it was open, we leave all makes closed and do not change the right pane
  });

  // Keyboard parity
  btn.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      btn.click();
    }
  });
});

    // Robust initialisation (prevents blank right pane):
    // 1) Honor a pre-marked .is-active panel
    const preset = q('.tab-panel.is-active');
    if (preset) {
      const id = preset.id;
      const link = q(`.tabs-rail a[data-panel="${id}"], .tabs-rail a[href="#${id}"]`);
      activateTab(id, link || null);
    } else {
      // 2) Else activate first visible model link
      const firstLink =
        q('.tabs-rail__list:not([hidden]) a[data-panel], .tabs-rail__list:not([hidden]) a[href^="#"]') ||
        q('.tabs-rail a[data-panel], .tabs-rail a[href^="#"]');
      if (firstLink) {
        const id = firstLink.dataset.panel || (firstLink.getAttribute('href') || '').replace(/^#/, '');
        activateTab(id, firstLink);
      } else {
        // 3) Last resort: show the first panel so right side isn't empty
        const firstPanel = q('.tab-panel');
        if (firstPanel) firstPanel.classList.add('is-active');
      }
    }
  });
});

/* Exit button injection (kept) */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function (details) {
    const content = details.querySelector('.mega-menu__content');
    if (!content) return;

    let btn = content.querySelector('.mega-exit-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mega-exit-btn';
      btn.setAttribute('aria-label', 'Close menu');
      btn.innerHTML = '<span class="mega-exit-icn" aria-hidden="true"></span><span class="mega-exit-label">Close</span>';
      content.appendChild(btn);
    }

    btn.addEventListener('click', () => details.removeAttribute('open'));
  });
});